import { create } from "zustand";
import type { SuccessResponse } from "@/types/api";
import apiClient from "../config/axiosConfig";

export interface FeatureFlags {
	curiosity: boolean;
	curiosity_training: boolean;
	elastic_search: boolean;
	abacus: boolean;
	how_to: boolean;
	curiosity_voice_beta: boolean;
}

interface FeatureFlagResponse {
	environment: string;
	flags: FeatureFlags;
	updatedAt: string;
}

interface FeatureFlagState {
	flags: FeatureFlags;
	environment: string;
	updatedAt: string;
	isLoading: boolean;
	error: string | null;
	fetchFeatureFlags: () => Promise<void>;
}

const environment = import.meta.env.VITE_CUSTOM_ENV_NAME || "development";

const defaultFlags: FeatureFlags = {
	curiosity: false,
	curiosity_training: true,
	elastic_search: false,
	abacus: false,
	how_to: false,
	curiosity_voice_beta: false,
};

export const useFeatureFlagStore = create<FeatureFlagState>((set) => ({
	flags: defaultFlags,
	environment: "",
	updatedAt: "",
	isLoading: false,
	error: null,

	fetchFeatureFlags: async () => {
		set({ isLoading: true, error: null });
		try {
			const response = await apiClient.get<
				SuccessResponse<FeatureFlagResponse>
			>(`/feature-flags/${environment}`);
			const data = response.data.data;
			set({
				flags: { ...defaultFlags, ...data.flags },
				environment: data.environment,
				updatedAt: data.updatedAt,
				isLoading: false,
			});
		} catch (error) {
			console.error("[FeatureFlags] Failed to fetch feature flags:", error);
			set({
				flags: defaultFlags,
				isLoading: false,
				error: "Failed to fetch feature flags",
			});
		}
	},
}));
